import { get } from 'lodash';
import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Popover as MuiPopover } from '@material-ui/core';
import * as Styled from './styled';

const Popover = ({ anchorEl, anchorOrigin, children, onClose, open, transformOrigin }) => (
  <MuiPopover
    open={open}
    onClose={onClose}
    anchorEl={get(anchorEl, 'current', null)}
    anchorOrigin={anchorOrigin}
    transformOrigin={transformOrigin}
    PaperProps={{ component: Styled.PopoverContainer }}
  >
    {children}
  </MuiPopover>
);

Popover.propTypes = {
  anchorEl: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.node,
    PropTypes.object
  ]),
  anchorOrigin: PropTypes.shape({
    vertical: PropTypes.string,
    horizontal: PropTypes.string,
  }),
  children: PropTypes.node.isRequired,
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  transformOrigin: PropTypes.shape({
    vertical: PropTypes.string,
    horizontal: PropTypes.string,
  }),
};

Popover.defaultProps = {
  anchorEl: null,
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'center',
  },
  transformOrigin: {
    vertical: 'bottom',
    horizontal: 'center',
  }
};

export default memo(Popover);